module.exports = __webpack_public_path__ + "img/delivery.599b685a.png";